import { shouldGroupSampleOrdersAsRoundTrips } from "./sampleOrderPreview";
import type { ImportMode } from "../types/customCsvImport";

export type CustomCsvPreviewUnit = "trade" | "fill";

export function resolveCustomCsvPreviewUnit(
  importMode?: ImportMode | string,
  layoutShapeId?: string
): CustomCsvPreviewUnit {
  return shouldGroupSampleOrdersAsRoundTrips(importMode, layoutShapeId) ? "trade" : "fill";
}

export type CustomCsvPreviewLabels = {
  unit: CustomCsvPreviewUnit;
  builtStatLabel: string;
  previewSectionTitle: string;
  readyReviewLine: string;
  runPreviewHint: string;
  noSampleBuilt: string;
};

export function customCsvPreviewLabels(
  importMode?: ImportMode | string,
  layoutShapeId?: string
): CustomCsvPreviewLabels {
  const unit = resolveCustomCsvPreviewUnit(importMode, layoutShapeId);
  if (unit === "fill") {
    return {
      unit,
      builtStatLabel: "Fills built",
      previewSectionTitle: "Fills we would import",
      readyReviewLine:
        "Your mapping looks correct. Review the sample rows and fills below, then continue to import. Nothing is saved until you confirm on the final step.",
      runPreviewHint:
        "Run preview to validate your mapping. You will see sample rows and the fills Tessera would create before anything is saved.",
      noSampleBuilt: "No sample fills built yet.",
    };
  }
  return {
    unit,
    builtStatLabel: "Trades built",
    previewSectionTitle: "Trades we would import",
    readyReviewLine:
      "Your mapping looks correct. Review the sample rows and trades below, then continue to import. Nothing is saved until you confirm on the final step.",
    runPreviewHint:
      "Run preview to validate your mapping. You will see sample rows and the trades Tessera would create before anything is saved.",
    noSampleBuilt: "No sample trades built yet.",
  };
}
